module.exports = __webpack_public_path__ + "img/goal-nine-br.b68d2655.png";